import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { toastHandler } from "@/lib/ToastHandler";
import { useAuth0 } from "@auth0/auth0-react";
import { motion } from "framer-motion";
import driverImg from "/driver-illustration/driver.svg";
import vectorImg from "/driver-illustration/vector.svg";
const Welcome = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    try {
      await loginWithRedirect();
    } catch (error) {
      console.error(error);
      toastHandler({
        title: "Oops!",
        description: "Error al iniciar sesión",
        variant: "destructive",
      });
    }
  };

  // No localStorage token checks; rely on Auth0 state
  useEffect(() => {}, []);

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gradient-to-br from-[#5829c8]/5 to-white">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#5829c8]"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex flex-col justify-between md:flex-row h-screen gap-4 bg-gradient-to-br from-[#5829c8]/5 to-white overflow-x-hidden">
      {/* Left panel */}
      <div className="flex-1 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="w-full p-8 md:p-12 flex flex-col justify-center space-y-8 max-w-lg"
        >
          <motion.img
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            src="/welcome-logo.png"
            alt="Gonau"
            className="h-10 md:h-12 w-auto mr-auto"
          />
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.6 }}
            className="w-full max-w-md mx-auto text-left flex flex-col items-start space-y-3 animate-fade-in"
          >
            <h1 className="text-2xl font-bold text-gray-900">
              Bienvenido a Gonau
            </h1>
            <p className="text-gray-600 text-sm">
              Con Gonau, cada interacción se convierte en un paso hacia una
              gestión más ágil y precisa, optimizando tu negocio.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.9 }}
            className="space-y-3"
          >
            <button
              onClick={handleLogin}
              className="w-full border border-[#5829c8] text-[#5829c8] py-3 font-medium hover:bg-[#5829c8]/5 transition rounded-xl"
            >
              Iniciar sesión
            </button>
          </motion.div>
        </motion.div>
      </div>
      {/* Right illustration panel */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="hidden md:flex w-1/2 h-full relative items-center justify-center rounded-3xl p-2"
      >
        <div className="relative w-full max-w-[800px] min-h-[800px] h-[calc(100%)] bg-[#5829c8] rounded-3xl overflow-hidden flex flex-col items-start justify-center lg:justify-start">
          <motion.h4
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            className="text-white text-5xl lg:text-6xl font-bold p-4 mb-10 lg:mb-0 lg:mt-56 xl:mt-40 ml-10"
          >
            Todo en <br /> un sólo lugar
          </motion.h4>
          <motion.img
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.6 }}
            src={vectorImg}
            alt="Decorative green curved line"
            className="absolute h-2/4 lg:h-4/6 right-0 top-0"
          />
          <motion.img
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.9 }}
            src={driverImg}
            alt="3D illustration of delivery person with purple house"
            className="w-4/5 lg:h-4/6 absolute max-w-[530px] left-0 bottom-0"
          />
        </div>
      </motion.div>
    </div>
  );
};

export default Welcome;
